var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"payment-failure-page"}},[_c('AppHero',{attrs:{"heading":'Your Purchase was not completed Successfully'}},[_c('p',{staticClass:"body-copy body-copy--align-center"},[_vm._v("Try again")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }